import makeStyles from '@material-ui/core/styles/makeStyles';
import _escape from 'lodash/escape';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import { HASHTAG, showText } from '../../app/utils';

const useStyles = makeStyles(
  () => ({
    hashTag: {
      color: color.$2,
      fontSize: 13,
      borderRadius: 4,
      backgroundColor: color.$20,
      padding: '5px 6px',
      cursor: 'default',
    },
  }),
  {
    name: 'HashtagSpan',
  },
);

export const HashtagSpan = ({ children }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <span className={classes.hashTag} contentEditable={false}>
      {t('customerName')}
      <span style={{ display: 'none' }}>{children}</span>
    </span>
  );
};

export const WhatsAppPlaceholderSpan = ({ children, decoratedText }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <span className={classes.hashTag} contentEditable={false}>
      {t('templates.whatsappTemplate.placeholderName', {
        number: decoratedText.match(/\d+/)[0],
      })}
      <span style={{ display: 'none' }}>{children}</span>
    </span>
  );
};

export const replaceHashtagText = (data = '') => {
  const classes = useStyles();
  const { t } = useTranslation();
  const HASHTAG_REGEX = new RegExp(_escape(HASHTAG), 'g');

  return data.replace(
    HASHTAG_REGEX,
    `<span class=${classes.hashTag}>${t('customerName')}</span>`,
  );
};

export const replaceWaTempPlaceholderText = (data = '') => {
  const classes = useStyles();
  const { t } = useTranslation();
  const WA_TEMP_PLACEHOLDER_REGEX = new RegExp(/\{\{(\d+)\}\}/, 'g');

  return data.replace(WA_TEMP_PLACEHOLDER_REGEX, (match, number) => {
    return `<span class=${classes.hashTag}>${t(
      'templates.whatsappTemplate.placeholderName',
      {
        number,
      },
    )}</span>`;
  });
};

export const HashtagText = data => {
  return replaceHashtagText(_escape(data));
};

export const HashtagUrlText = data => {
  return replaceHashtagText(showText(data));
};

export const WaTempPlaceholderText = (data = '') => {
  return replaceWaTempPlaceholderText(_escape(data));
};

export const WaTempPlaceholderUrlText = data => {
  return replaceWaTempPlaceholderText(showText(data));
};

export default HashtagText;
